import { FC } from "react";

import { FormButton } from "@/forms-design-system/FormButton";
import { FormInfobox, FormInfoboxProps } from "@/forms-design-system/FormInfobox";
import { useTranslate } from "@/hooks/useTranslate";
import { Info } from "@/icons/outlined";

type ThemedZeffySplitOrCoverFeesInfoboxProps = Omit<
  FormInfoboxProps,
  "icon" | "title" | "description" | "components" | "variant" | "callToActions" | "onDismiss"
> & {
  formattedFees: string;
  organizationName: string;
  onSplitFeesClick: () => void;
  onCoverFeesClick: () => void;
  onDismiss: () => void;
};

export const ThemedZeffySplitOrCoverFeesInfobox: FC<ThemedZeffySplitOrCoverFeesInfoboxProps> = ({
  organizationName,
  formattedFees,
  onSplitFeesClick,
  onCoverFeesClick,
  onDismiss,
  ...rest
}) => {
  const { t } = useTranslate();
  return (
    <FormInfobox
      {...rest}
      variant="emphasis"
      icon={<Info />}
      title={t("common", "payment.coverFees.title")}
      description={t("common", "payment.coverFees.messageA", { orgName: organizationName })}
      callToActions={[
        <FormButton key="coverFees" onClick={onCoverFeesClick}>
          {t("common", "payment.coverFees.coverFees", { formattedFees })}
        </FormButton>,
        <FormButton key="splitFees" variant="tonal" onClick={onSplitFeesClick}>
          {t("common", "payment.coverFees.splitFees")}
        </FormButton>,
      ]}
      onDismiss={onDismiss}
    />
  );
};
